import React from 'react';
import DateFilterDropdown from '../../common/components/_DateFilterDropdown';
import GenericInsightsDropdown from './GenericInsightsDropdownJsFile';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import SearchInput from '../../common/components/_SearchBox';
import { addFilter } from '../../common/services/navigation';
import PropTypes from 'prop-types';

function Filter({ search, filters, settings }) {
    let data = d => {
        return d.children.map(c => ({ checked: (search.keywords1 && search.keywords1.toString().split(',').includes(c.key) ? true : false ), label: c.name, value: c.key, children: c.children.map(ch => ({ label:ch.name, value: ch.key})) }));
    };

    const onChange = (currentNode) => {
        addFilter(search, 'keywords1', currentNode.value, currentNode.checked);
      };

	return (
        <div className="filter-bar">
            <div className="filter__text">
                Filter by
            </div>

            {/* 
            
            filters.taxonomyFilters.industry - industry is the api name of the Content Type taxonomy component, case sensitive. 
            Name property of DropdownItem component is added as the query string and must match the Content Type component api name
            Name of Taxonomy must also be included in config.js as a taxonomyFilters property
            
            */}

            <SearchInput search={search} settings={settings}/>
            
            {filters && filters.taxonomyFilters && settings.microsite == "TWIInnovationNetwork" && <GenericInsightsDropdown search={search} title='Industries' options={filters.taxonomyFilters.innovationNetworkIndustry} name='innovationNetworkIndustry' istaxonomy={true} />}
            {filters && filters.taxonomyFilters && settings.microsite == "TWIInnovationNetwork" && <GenericInsightsDropdown search={search} title='Topics' options={filters.taxonomyFilters.innovationNetworkTopics} name='innovationNetworkTopics' istaxonomy={true} />}

            {filters && filters.taxonomyFilters && settings.microsite != "TWIInnovationNetwork" && <GenericInsightsDropdown search={search} title='Industries' options={filters.taxonomyFilters.industry} name='industry' istaxonomy={true} />}
            {filters && filters.taxonomyFilters && settings.microsite != "TWIInnovationNetwork" && <DropdownTreeSelect name="keywords1" data={data(filters.taxonomyFilters.keywords1)} onChange={onChange} keepTreeOnSearch='true' clearSearchOnChange='true' placeholderText='Topics...' />}

            
        
            
            <DateFilterDropdown search={search} isYear={true} settings={settings} />
        </div>
	);
}

Filter.propTypes = {
    search: PropTypes.object,
    filters: PropTypes.object,
    settings: PropTypes.object,
};

export default Filter;
